/**
 * @file
 */

import { customValidationInit, aspControlValidationInit } from "@/common/validation/init.js";
import { processESignCustom } from "@/common/validation/utils.js";


var submitChanges = false;

export function InitializeAutoDebitEnrollmentPages()
{
   // ===========================================================================================
   // Enable hover tool tips.
   // ===========================================================================================
   $(document).tooltip();

   //  --------------------------------
   //  init the validation engine       
   //  -------------------------------- 
   var onSubmit = false;
   customValidationInit(onSubmit);
   aspControlValidationInit();

   // ================================================================================
   // Add a click event to the note about checkbox requirements for esign submission
   // ================================================================================
   $('.scrollToBOP').click(function (e) {
      $('html, body').animate({ scrollTop: $("a[href^='#BOP']")?.offset()?.top }, 125)
   });

   //  ----------------------------------------------------------------------------------------------------------------- 
   //  Modify checkbox logic to behave as if it were a radio button list.ie only one checkbox at a time can be checked.  
   //  The group of checkboxes behaving as a radio button list have the classname cbFfelpCash to identify them.          
   //  ----------------------------------------------------------------------------------------------------------------- 
   $(".cbFfelpCash input[type='checkbox']").click(function (e)
   {
      // -----------------------------
      // uncheck all the checkboxes
      // -----------------------------
      $(".cbFfelpCash input[type='checkbox']").prop('checked',false);
      // ---------------------------------------------------------
      // check the checkbox that is associated with this event
      // ---------------------------------------------------------
      $(this).prop('checked', true);
   });

   $("[id$='tbAddAmt']").change(function () {
      if ($("[id$='hdnOtherBrand']").val() == "N") {
         if (Number($("[id$='tbAddAmt']").val()) > 0) 
            $("div[id$='divPaidAhead']").toggleClass('ui-helper-hidden', false);
         else
            $("div[id$='divPaidAhead']").toggleClass('ui-helper-hidden', true);
      }
   });

   // --------------------------------------------------------------------------
   // submit dialog box
   // N.B. submitChanges is a global variable defined at the top of this script
   // --------------------------------------------------------------------------
   $("[id$='divForbContinueDialog']").dialog({
      autoOpen: false,
      modal: true,
      resizable: false,
      title: "CONFIRMATION",
      width: 400,
      dialogClass: 'no-close',
      buttons: {
         "YES": {
            text: "YES",
            class: 'twoColorButton',
            click: function () {
               submitChanges = true;
               $("[id$='btnContinue']").click();
            }
         },
         "NO": {
            text: "NO",
            class: 'secondaryButton',
            click: function () {
               $(this).dialog("close");
            }
         }
      }
   });

  // @ts-ignore Hack for aspx page direct use -- A.M. 2025-09-12
  window.HandleSubmitClick = HandleSubmitClick;
  // @ts-ignore Hack for aspx page direct use -- A.M. 2025-09-12
  window.confirmExit = confirmExit;
  // @ts-ignore Hack for aspx page direct use -- A.M. 2025-09-12
  window.bValidateCB = bValidateCB;
};

// --------------------------------------------------------------------------
// used by the review dialog box
// N.B. submitChanges is a global variable defined at the top of this script
// --------------------------------------------------------------------------
function HandleSubmitClick() {
      // -------------------------------------------------------------------
      // N.B. Variable named hdnPastDue is populated by the code behind.
      //      If no existence assume false because there is some error
      //      as the field is defined on the page with a default value of FALSE.
      // -------------------------------------------------------------------
  const askQuestion = $("[id$='hdnPastDue']").val() ?? 'FALSE';

      // -------------------------------------------------------------------
      // check to see if we need the pop up message
      // -------------------------------------------------------------------
      if (askQuestion === 'TRUE') {
         // -------------------------------------------------------------------
         // check to see if the pop up has been displayed and processed
         // -------------------------------------------------------------------
         if (submitChanges) {
            // ----------------------------------------
            // changes confirmed, proceed with submit
            // ----------------------------------------
            submitChanges = false;
            return processESignCustom();
         } else {
            // ---------------------------------------------
            // display pop up for confirmation to continue
            // ---------------------------------------------
            $("[id$='divForbContinueDialog']").dialog("open");
            return false;
         }
      } else {
         // ------------------------------------------------------------
         // no need for pop up, just do what we did before TMS 262754
         // ------------------------------------------------------------
         return processESignCustom();
      }

}

//  --------------------------------------- 
//  alert borrower about leaving the esign  
//  --------------------------------------- 
function confirmExit() {
   return (confirm("Your application will be saved for 30 days from when you started this eSign process if you click 'ok'."))
}

//  -------------------------------------------- 
//  this variable is passed to validation engine 
//  to tell it if the checkboxes should be       
//  validated. the checkboxes are only displayed 
//  for borrowers who have ffelp and cash loans  
//  -------------------------------------------- 
var bValidateCB = false;
